var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-full p-3 rounded-lg bg-white flex flex-col gap-y-2" },
    _vm._l(_vm.userInfos, function (userInfo, i) {
      return _c("div", { key: i, staticClass: "flex items-center gap-x-2" }, [
        _c(
          "p",
          {
            staticClass: "w-max px-2 text-xs text-blue-400 font-bold leading-6",
          },
          [_vm._v(_vm._s(userInfo.title))]
        ),
        _c(
          "p",
          { staticClass: "min-w-0 flex-1 text-xs font-bold break-words" },
          [_vm._v(_vm._s(userInfo.value))]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }